import { splitUom } from './parseUom'
import { UomTable } from './UomTable'
import _uomTable from './uomTable.json'

const uomTable = _uomTable as UomTable

export const convertSingleUom = (valueIn: number, uomIn: string, uomOut: string) => {
  if (valueIn === null || valueIn === undefined) return
  if (uomIn === uomOut) return valueIn

  const rowIn = uomTable[uomIn]
  const rowOut = uomTable[uomOut]

  if (!rowIn || !rowOut) return
  if (rowIn.dimension !== rowOut.dimension) return

  let valueOut = valueIn
  // Convert uomIn value to canonical value
  if (rowIn.orderToCanonical === 'ADD_FIRST') {
    valueOut = (valueOut + rowIn.offset) * rowIn.factor
  } else {
    valueOut = valueOut * rowIn.factor + rowIn.offset
  }

  // If uomOut is already canonical, conversion is done. Return valueOut
  if (rowOut.isCanonical) return valueOut

  // convert canonical value to uomOut value
  if (rowOut.orderToCanonical === 'ADD_FIRST') {
    valueOut = (valueOut / rowOut.factor) - rowOut.offset
  } else {
    valueOut = (valueOut - rowOut.offset) / rowOut.factor
  }

  return valueOut
}


export const convertUom = (valueIn: number, uomIn: string, uomOut: string) => {
  const [numIn, denomIn] = splitUom(uomIn)
  if (!denomIn) return convertSingleUom(valueIn, uomIn, uomOut)

  const [numOut, denomOut] = splitUom(uomOut)
  const numFactor = convertSingleUom(valueIn, numIn, numOut)
  const denomFactor = convertSingleUom(1, denomIn, denomOut)

  if (numFactor == null || denomFactor == null) return
  return numFactor / denomFactor
}
